import ClosingPage from "./ClosingPage";

export default ClosingPage;
